import { render, staticRenderFns } from "./TimerIcon.vue?vue&type=template&id=53037bae"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53037bae')) {
      api.createRecord('53037bae', component.options)
    } else {
      api.reload('53037bae', component.options)
    }
    module.hot.accept("./TimerIcon.vue?vue&type=template&id=53037bae", function () {
      api.rerender('53037bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/TimerIcon.vue"
export default component.exports